import Decimal from 'decimal.js';
/**
 * A dedicated Decimal constructor so our precision settings never leak into or from
 * other libraries. 30 significant digits is far beyond what recipe math needs.
 */
export const Dec = Decimal.clone({ precision: 30, rounding: Decimal.ROUND_HALF_UP });
export function dec(value) {
    if (typeof value === 'number' && !Number.isFinite(value)) {
        throw new TypeError('Cannot convert non-finite number to Decimal');
    }
    return new Dec(value);
}
/** Canonical decimal string: no exponent, no trailing zeros, "-0" normalized to "0". */
export function toDecimalString(value) {
    const d = dec(value);
    if (d.isZero())
        return '0';
    const fixed = d.toFixed();
    if (!fixed.includes('.'))
        return fixed;
    return fixed.replace(/0+$/, '').replace(/\.$/, '');
}
export function isZero(value) {
    return value === null || value === undefined ? true : dec(value).isZero();
}
export function decEquals(a, b) {
    return dec(a).equals(dec(b));
}
//# sourceMappingURL=decimal.js.map